import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import { listStoreInstagramPhotos } from "../../Redux/Actions/InstagramPhotoActions";

import {
  Swiper,
  SwiperSlide,
} from "swiper/react";

import { Autoplay } from "swiper/modules";

import "swiper/css";
import "../styles/instagram-photos.css";

const InstagramPhotosCarousel = () => {
  const dispatch = useDispatch();

  const [selectedPhoto, setSelectedPhoto] =
    useState(null);

  const instagramPhotoState = useSelector(
    (state) =>
      state.instagramPhotoStoreList
  );

  const {
    loading,
    error,
    photos: rawPhotos,
  } = instagramPhotoState || {};

  const photos = useMemo(() => {
    return Array.isArray(rawPhotos)
      ? rawPhotos.slice(0, 12)
      : [];
  }, [rawPhotos]);

  useEffect(() => {
    if (!photos.length) {
      dispatch(
        listStoreInstagramPhotos()
      );
    }
  }, [dispatch, photos.length]);

  useEffect(() => {
    if (!selectedPhoto) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setSelectedPhoto(null);
      }
    };

    const previousOverflow =
      document.body.style.overflow;

    document.body.style.overflow =
      "hidden";

    window.addEventListener(
      "keydown",
      handleKeyDown
    );

    return () => {
      document.body.style.overflow =
        previousOverflow;

      window.removeEventListener(
        "keydown",
        handleKeyDown
      );
    };
  }, [selectedPhoto]);

  const openPhoto = (photo) => {
    setSelectedPhoto(photo);
  };

  const closePhoto = () => {
    setSelectedPhoto(null);
  };

  const handleLightboxBackgroundClick = (
    event
  ) => {
    if (
      event.target === event.currentTarget
    ) {
      closePhoto();
    }
  };

  if (
    loading &&
    !photos.length
  ) {
    return (
      <section className="looks-photo-section">
        <div className="site-shell">
          <div className="site-shell-inner">
            <p className="looks-photo-status">
              Cargando inspiración...
            </p>
          </div>
        </div>
      </section>
    );
  }

  if (
    error ||
    !photos.length
  ) {
    return null;
  }

  return (
    <>
      <section className="looks-photo-section">
        <div className="site-shell">
          <div className="site-shell-inner">
            <div className="looks-photo-header">
              <div>
                <h2>
                  Inspírate con Alta Moda
                </h2>

                <p>
                  Descubre nuestros looks,
                  colecciones y tendencias
                  favoritas.
                </p>
              </div>
            </div>

            <div className="looks-photo-swiper-wrap">
              <Swiper
                modules={[Autoplay]}
                loop={photos.length > 1}
                autoplay={
                  photos.length > 1
                    ? {
                        delay: 3500,
                        disableOnInteraction:
                          false,
                        pauseOnMouseEnter:
                          true,
                      }
                    : false
                }
                grabCursor
                watchOverflow
                speed={650}
                spaceBetween={18}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 14,
                  },

                  480: {
                    slidesPerView: 2,
                    spaceBetween: 14,
                  },

                  768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                  },

                  1100: {
                    slidesPerView: 4,
                    spaceBetween: 18,
                  },

                  1400: {
                    slidesPerView: 6,
                    spaceBetween: 18,
                  },
                }}
              >
                {photos.map((photo) => (
                  <SwiperSlide
                    key={photo._id}
                  >
                    <article className="looks-photo-card">
                      <button
                        type="button"
                        className="looks-photo-media"
                        onClick={() =>
                          openPhoto(photo)
                        }
                        aria-label={`Ampliar ${photo.title}`}
                        title="Ver imagen completa"
                      >
                        <img
                          src={photo.imageUrl}
                          alt={photo.title}
                          loading="lazy"
                          decoding="async"
                        />

                        <span
                          className="looks-photo-zoom"
                          aria-hidden="true"
                        >
                          <i className="fas fa-search-plus" />
                        </span>
                      </button>
                    </article>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      {selectedPhoto && (
        <div
          className="photo-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label={`Vista ampliada de ${selectedPhoto.title}`}
          onMouseDown={
            handleLightboxBackgroundClick
          }
        >
          <div className="photo-lightbox-content">
            <button
              type="button"
              className="photo-lightbox-close"
              onClick={closePhoto}
              aria-label="Cerrar imagen"
              title="Cerrar"
            >
              &times;
            </button>

            <img
              src={selectedPhoto.imageUrl}
              alt={selectedPhoto.title}
            />

            {/* {selectedPhoto.title && (
              <h3>
                {selectedPhoto.title}
              </h3>
            )} */}
          </div>
        </div>
      )}
    </>
  );
};

export default InstagramPhotosCarousel;